<template>
  <div class="p-login">
    <switchover-banner v-if="!$infobarDisabled" />
    <!-- <h1>Login</h1> -->

    <form
      class="c-login-form c-form"
      @submit.prevent="onLoginFormSubmit"
      v-show="!loggedIn"
      novalidate="true"
      autocomplete="off"
    >
      <header class="c-login-form__header">
        <cactus-logo></cactus-logo>
      </header>
      <!-- <h1>Login</h1> -->
      <div v-if="!loading">
        <picture @click="azureLogin" class="cursor-pointer" v-if="!$msLoginDisabled">
          <source
            srcset="/assets/ms-signin-dark.svg"
            media="(prefers-color-scheme: dark)"
          />
          <img src="/assets/ms-signin-light.svg" alt="Sign in with Microsoft" />
        </picture>
        <form-field
          full-width
          name="username"
          label="Username"
          v-model.lazy="username"
          v-validate="'required|email'"
          :error="errors.first('username')"
          type="email"
          v-if="!$emailLoginDisabled"
        ></form-field>
        <form-field
          full-width
          name="password"
          label="Password"
          type="password"
          v-model.lazy="password"
          v-validate="{ required: true }"
          :error="errors.first('password')"
          v-if="!$emailLoginDisabled"
        ></form-field>
        <div class="c-form__group">
          <!-- <button class="c-btn c-btn--primary" type="submit" :disabled="!password">Login</button> -->
          <base-button v-if="!$emailLoginDisabled">Login</base-button>
        </div>
      </div>

      <loading v-else></loading>
    </form>

    <p v-if="loggedIn">Successfully logged in, redirecting...</p>
    <div v-if="authErrors">
      <p
        class="c-login-error"
        v-for="error in authErrors"
        :key="authErrors.indexOf(error)"
      >
        {{ error.message }}
      </p>
    </div>
    <p class="c-login-success" v-if="success">Login successful!</p>
  </div>
</template>

<script>
import CactusLogo from '@/components/CactusLogo';

const SwitchoverBanner = () => import('@/components/SwitchoverBanner');
export default {
  name: 'login',

  methods: {
    onLoginFormSubmit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store.dispatch("auth/login");
        }
      });
    },
    async azureLogin() {
      // try to login via azure.
      let response;

      this.$msal.loginRedirect({});
    },
  },

  computed: {
    loading() {
      return this.$store.state.auth.loading;
    },
    loggedIn() {
      return this.$store.state.auth.token;
    },

    authErrors() {
      return this.$store.state.auth.authErrors;
    },

    success() {
      return this.$store.state.auth.success;
    },

    username: {
      get() {
        return this.$store.state.auth.username;
      },
      set(value) {
        this.$store.commit("auth/setUsername", value);
      },
    },

    password: {
      get() {
        return this.$store.state.auth.password;
      },
      set(value) {
        this.$store.commit("auth/setPassword", value);
      },
    },
  },

  components: {
    CactusLogo,
    SwitchoverBanner,
  },

  async mounted() {
    /**
     * Check to see if we have a valid Azure session
     * Might still have a valid token (acquireTokenSilent) or have come from redirect flow
     * Get a token and send to our endpoint
     * Not if it is disabled
     *
     */

    if (this.$msLoginDisabled) {
      return null;
    }
    let token = null;

    try {
      token = await this.$store.dispatch("auth/handleAzureLogin");
      if (token && token.idToken) {
        await this.$store.dispatch("auth/azureLogin", token.idToken);
      }
    } catch (err) {
      console.error(err);
    }
  },
};
</script>

<style lang="scss">
.p-login {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: $colour-nhs-blue;
}

.c-login-form {
  background: $colour-nhs-white;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 3em 4em;
  width: 420px;
  border-radius: 6px;

  &__header {
    margin: 1em 0;
  }
}

.c-login-error,
.c-login-success {
  color: $colour-nhs-white;
  padding: 1em;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin-top: 0;
  width: 100%;
}

.c-login-error {
  background: $colour-nhs-emergency-red;
}

.c-login-success {
  background: rgb(39, 201, 74);
}
</style>
